import type { Prisma } from "@prisma/client";

import { hasCapability, type User } from "../base";
import { NON_EXISTENT_ID } from "../utils/types";

export const bidRequest = {
  read: (user: User) => hasCapability(user, "bidRequest.read"),
  create: (user: User) => hasCapability(user, "bidRequest.create"),
  update: (user: User) => hasCapability(user, "bidRequest.update"),
  updateStatus: (user: User, buyerOrganizationId: string) => {
    if (hasCapability(user, "bidRequest.updateStatus.all")) {
      return true;
    }
    if (hasCapability(user, "bidRequest.updateStatus.org")) {
      return user.person.organizationId === buyerOrganizationId;
    }
    return false;
  },
};

export const bidRequestWhere = (user: User) => {
  if (hasCapability(user, "bidRequest.read.all")) {
    return {};
  }

  const clauses: Prisma.BidRequestWhereInput[] = [];

  if (hasCapability(user, "bidRequest.read.org")) {
    clauses.push({ buyerOrganizationId: user.person.organizationId });
  }

  if (clauses.length === 0) {
    return { AND: [{ id: NON_EXISTENT_ID }] };
  }
  return { OR: clauses };
};
